import { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { AdminUserInterface } from './AdminUser'
import WebService from '../../utility/WebService'
import { useForm } from 'react-hook-form'
import CustomButton from '../../components/CustomButton/CustomButton'
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons'
interface Props {
    isShow: boolean
    isClose: any
    user?: AdminUserInterface | null
}

interface PasswordForm {
    newPassword: string
    confirmPassword: string
}

const ChangePasswordBlade = ({ isShow, isClose, user }: Props) => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm<PasswordForm>()

    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const onSubmit = (data: PasswordForm) => {
        const requestBody = {
            id: user?._id,
            password: data.newPassword,
            confirmPassword: data.confirmPassword
        }

        setIsLoading(true)
        WebService.postAPI({
            action: 'admin-user/user/change-password',
            body: requestBody,
            id: 'changePasswordButton'
        })
            .then(() => {
                toast.success('Password changed successfully.')
                setIsLoading(false)
                isClose(true)
            })
            .catch(() => {
                toast.error('Failed to change password.')
                setIsLoading(false)
            })
    }

    return (
        <Offcanvas
            show={isShow}
            onHide={isClose}
            placement={'end'}
            className="offcanvas-small"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Change Password</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="border-bottom px-0 information-main-view ">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="px-3 form-style">
                        {/* New Password */}
                        <div className="form-group mb-2">
                            <Form.Label className="label">
                                New Password <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="input-group" style={{ flexWrap: "nowrap" }}>
                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4l-2.3-2.3a1 1 0 0 0-1.4 0l-2.1 2.1a1 1 0 0 0 0 1.4Z" />
                                        <path d="m21 2-9.6 9.6" />
                                        <circle cx="7.5" cy="15.5" r="5.5" />
                                    </svg>
                                </span>
                                <input
                                    type={showNewPassword ? 'text' : 'password'}
                                    className="form-control ps-0 pe-2 border-0 mb-0"
                                    placeholder="New Password"
                                    {...register('newPassword', {
                                        required: ' Enter new password',
                                        minLength: {
                                            value: 6,
                                            message: 'Password must be at least 6 characters'
                                        },
                                        pattern: {
                                            value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
                                            message: 'Password must contain one Uppercase letter, one Number, and one Special character'
                                        }
                                    })}
                                     style={{ height: "35px", fontSize: "14px" }}
                                />
                                <span
                                    className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                    onClick={() => setShowNewPassword(prev => !prev)}
                                >
                                    {showNewPassword ? <EyeSlashFill size={16} /> : <EyeFill size={16} />}
                                </span>
                            </div>

                            {errors.newPassword && (
                                <div className="error-message">{errors.newPassword.message}</div>
                            )}
                        </div>

                        {/* Confirm Password */}
                        <div className="form-group mt-2">
                            <Form.Label className="label">
                                Confirm Password <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="input-group" style={{ flexWrap: "nowrap" }}>
                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4l-2.3-2.3a1 1 0 0 0-1.4 0l-2.1 2.1a1 1 0 0 0 0 1.4Z" />
                                        <path d="m21 2-9.6 9.6" />
                                        <circle cx="7.5" cy="15.5" r="5.5" />
                                    </svg>
                                </span>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    className="form-control ps-0 pe-2 border-0 mb-0"
                                    placeholder="Confirm Password"
                                    {...register('confirmPassword', {
                                        required: ' Enter confirm password',
                                        validate: (val) => val === watch('newPassword') || 'Passwords do not match'
                                    })}
                                        style={{ height: "35px", fontSize: "14px" }}
                                />
                                <span
                                    className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                                >
                                    {showConfirmPassword ? (<EyeSlashFill size={16} />) : (<EyeFill size={16} />)}
                                </span>
                            </div>
                            {errors.confirmPassword && (
                                <div className="error-message">{errors.confirmPassword.message}</div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 p-3 mt-5">
                        <button
                            className="btn btn-outline-secondary flex-fill"
                            type="button"
                            onClick={isClose}
                            style={{ maxWidth: '150px' }}
                        >
                            Cancel
                        </button>
                        <CustomButton
                            isLoading={isLoading}
                            label="Save"
                            className="flex-fill"
                            type="submit"
                            id="saveUserButton"
                            style={{ maxWidth: '150px' }}
                        />
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default ChangePasswordBlade
